function copyCode(id) {
  const element = document.getElementById('code_' + id);
  if (!element) {
    return;
  }

  const code = element.innerText || element.textContent;

  if (navigator.clipboard) {
    navigator.clipboard.writeText(code);
  } else {
    const textarea = document.createElement('textarea');
    textarea.value = code;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }

  // Changer la couleur et le libellé du bouton
  const btn = document.getElementById('btn_copy_' + id);
  if (btn) {
    const originalText = btn.innerText;
    const originalBg = btn.style.backgroundColor;
    btn.innerText = 'copié';
    btn.style.backgroundColor = 'green';
    setTimeout(() => {
      btn.innerText = originalText;
      btn.style.backgroundColor = originalBg;
    }, 1500);
  }

  console.log('Code copié :', code);
}

window.copyCode = copyCode;

export default copyCode;
